import useStyles from './useStyles'
import { IconButton, Tooltip } from '@mui/material'
import ModalMenuItem from '../Modals/ModalMenuItem.jsx'
import GppGoodOutlinedIcon from '@mui/icons-material/GppGoodOutlined'
import GppBadOutlinedIcon from '@mui/icons-material/GppBadOutlined'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'; import { buildUserDisplayName } from '../../../../../utils/adminAccessUserHelpers.js'
import { namesTypesTraduc } from '../../../../../utils/traducTypes.js'

function TableItem({ item, onConfigureUser, typesUser }) {
  const classes = useStyles()

  const getIconStatus = (code) => {
    switch (code) {
      case 'ACTIVE':
        return (
          <Tooltip title="Activo">
            <IconButton>
              <GppGoodOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'WAITING_VALIDATION':
        return (
          <Tooltip title="Esperando validación">
            <IconButton>
              <InfoOutlinedIcon className={classes.hoverButton} />
            </IconButton>
          </Tooltip>
        )
      case 'INACTIVE':
      case 'DELETED':
      case 'BLOCKED':
      case 'SUSPENDED':
        return (
          <Tooltip title={'No activo'}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )


      default:
        return (
          <Tooltip title={code}>
            <IconButton>
              <GppBadOutlinedIcon className={classes.hoverButtonDelete} />
            </IconButton>
          </Tooltip>
        )
    }
  }

  return (
    <>
      <tr className={classes.row}>
        <td className={classes.itemIcon}>
          {getIconStatus(
            item?.status?.userStatusCode
          )}
        </td>
        <td className={classes.itemEmail}>{buildUserDisplayName(item)}</td>
        <td className={classes.itemName}>
          {item?.account?.email || "-"}
        </td>
        <td className={classes.itemRoleUser}>{namesTypesTraduc.find(
          (option) =>
            option.code ===
            item?.type?.organizationUserTypeCode,
        )?.name || "-"}</td>
        <td className={classes.itemKebab}>
          <ModalMenuItem
            item={item}
            onConfigureUser={onConfigureUser}
          />
        </td>
      </tr>
    </>
  )
}

export default TableItem
